import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, useHistory } from 'react-router-dom';
import { Edit, Delete, Visibility, ContentCopy, Check, Add } from '@mui/icons-material';
import { Typography, Tooltip } from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import EmptyState from '../../../components/EmptyState';
import messages from '../../../assets/locale/messages';
import userImage from '../../../assets/images/user-profile-image.png';
import banner from '../../../assets/images/banner.png';
import { isSuperAdmin } from '../../../utils/Permissions';
import { ROUTE_PATHS } from '../../../utils/RoutesPaths';
import { providerStatusList, mimarCommissionList } from '../../../utils/Constants';
import {
  deleteProviderRequest,
  getGeneratedPasswordRequest,
  getProviderDetailsRequest,
  getProviderDetailsResponse,
} from '../../../store/Providers/actions';
import { renderTextEllipsis, setPageMainTitle } from '../../../utils/Helpers';
import {
  addBranchDataInStore,
  addBranchResponse,
  getAddressFromCoordsResponse,
  getBranchResponse,
  getBranchServicesResponse,
} from '../../../store/Branches/actions';
import { getGoogleMapsCoords, getGoogleMapsPolygon, saveBranchData } from '../../../store/GoogleMapCoords/actions';
import './ViewServiceProviders.scss';

const ViewServiceProviders = () => {
  const history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();
  const createdBranchData = useSelector((state) => state.branches.savedBranchData);

  const providerDetails = useSelector((state) => state.providers.providerDetails);

  const generatePassword = useSelector((state) => state.providers.generatedPassword);
  const lang = useSelector((state) => state.locale.lang);
  const { shared, serviceProviders, pagesTitles, serviceProviderCategories } = messages[lang];

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [openShowPaswword, setOpenShowPaswword] = useState(false);
  const [showConfirmPasswordCopy, setShowConfirmPasswordCopy] = useState(false);

  const [displayGeneratePasswordButton, setDisplayGeneratePasswordButton] = useState(false);

  useEffect(() => {
    if (showConfirmPasswordCopy) {
      setTimeout(() => {
        setShowConfirmPasswordCopy(false);
      }, 3000);
    }
  }, [showConfirmPasswordCopy]);

  useEffect(() => {
    setPageMainTitle('serviceProvidersManagement');
    window.scrollTo(0, 0);
    if (createdBranchData !== null) {
      dispatch(addBranchDataInStore(null));
      dispatch(saveBranchData(null));
    }
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(getProviderDetailsRequest(id));
    }
    return () => {
      dispatch(getProviderDetailsResponse({}));
    };
  }, [dispatch, id]);

  useEffect(() => {
    mustChangePassword()
  }, [providerDetails])

  const handleDeleteServiceProvider = () => {
    dispatch(
      deleteProviderRequest({
        id,
      })
    );
    setOpenDeleteConfirm(false);
  };

  const generateRandomPassword = () => {
    let mangerId;
    if (providerDetails?.service_provider_managers?.length > 0) {
      mangerId = providerDetails.service_provider_managers?.filter((manger) => {
        return manger.is_super_manager;
      })[0]?.id;
    }
    dispatch(
      getGeneratedPasswordRequest({
        id,
        mangerId,
      })
    );
  };

  const copy = () => {
    navigator.clipboard.writeText(generatePassword).then(() => setShowConfirmPasswordCopy(true));
  };

  const handleEmailChecker = () => {
    if (providerDetails?.service_provider_managers?.length > 0) {
      let SuperMangers = providerDetails.service_provider_managers?.filter((manger) => manger.is_super_manager);
      return <div>{SuperMangers[0].email}</div>;
    } else {
      return <div>{providerDetails.email ?? '-'}</div>;
    }
  };

  const mustChangePassword = () => {
    let SuperMangers = providerDetails?.service_provider_managers?.filter((manger) => manger.is_super_manager);
    if( SuperMangers ){
      setDisplayGeneratePasswordButton(SuperMangers[0].must_change_password)
    }
  };

  const viewBranchDetails = (branch) => {
    history.push(ROUTE_PATHS.viewBranch.replace(':id', branch.id));
  };

  const clearAddBranchSavedDataInStore = () => {
    dispatch(getBranchResponse({}));
    dispatch(getBranchServicesResponse({}));
    dispatch(addBranchDataInStore({}));
    dispatch(addBranchResponse({}));
    dispatch(getAddressFromCoordsResponse({}));
    dispatch(saveBranchData({}));
    dispatch(getGoogleMapsPolygon([]));
    dispatch(getGoogleMapsCoords({}));
  };

  const openAddBranchFlow = () => {
    clearAddBranchSavedDataInStore();
    history.push({ pathname: ROUTE_PATHS.addProvidersBranch.replace(':providerid', id),search: `?CurrentTab=${1}` });
  };

  const renderShowPassowrdContent = () => {
    return (
      <>
        <div className="row align-items-center">
          <div className="col-12 col-md-9">
            <div className="d-flex flex-column flex-md-row gap-2">
              <div>{serviceProviders.viewServiceProvider.passwordIs}</div>
              <div>
                <b>{generatePassword ?? '-'}</b>
              </div>
            </div>
          </div>
          {generatePassword && (
            <div className="col-12 col-md-3 mt-3 mt-md-0 font-bold">
              <Button
                label={
                  <>
                    {showConfirmPasswordCopy ? <Check /> : <ContentCopy />}
                    <span className="mx-2">{showConfirmPasswordCopy ? shared.copied : shared.copy}</span>
                  </>
                }
                outlined
                color="info"
                className={`btn-info-generate-password fsize-14 m-0`}
                onClick={() => copy()}
              />
            </div>
          )}
        </div>
      </>
    );
  };

  console.log(providerDetails?.commercial_registration_file_url?.split('/').slice(-1)[0].split('_').pop())

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <Typography variant="h4" sx={{ flexGrow: 1 }} className={`page-title ${lang === 'en' ? 'me-5' : 'ms-5'}`}>
          {providerDetails
            ? providerDetails.name_en || providerDetails.name_ar
              ? lang === 'en'
                ? providerDetails.name_en
                : providerDetails.name_ar
              : pagesTitles.serviceProvidersView
            : pagesTitles.serviceProvidersView}
        </Typography>
        <div className="actions-container d-flex justify-content-end mt-4 mt-xl-0 flex-column flex-sm-row gap-3">
          {isSuperAdmin() && (
            <Link to={ROUTE_PATHS.editServiceProvider.replace(':id', id)}>
              <Button
                label={
                  <>
                    <Edit />
                    <span className="mx-2">{shared.edit}</span>
                  </>
                }
                className={`fsize-14 btn-secondary text-white`}
                btnStyle="secondary"
              />
            </Link>
          )}
          {isSuperAdmin() && (
            <Button
              label={
                <>
                  <Delete />
                  <span className="mx-2">{shared.delete}</span>
                </>
              }
              outlined
              className="fsize-14"
              onClick={() => setOpenDeleteConfirm(true)}
            />
          )}
          {displayGeneratePasswordButton && (
            <Button
              color="info"
              outlined
              label={
                <>
                  <Visibility />
                  <span className="mx-2">{serviceProviders.list.generatePassword}</span>
                </>
              }
              className={`fsize-14 btn-info-generate-password`}
              onClick={() => {
                setOpenShowPaswword(true);
                generateRandomPassword();
              }}
            />)
          }
        </div>
      </div>
      <div
        className={`px-3 px-md-5 bg-white rounded-4 providers-details-page mt-4 ${
          !providerDetails && 'd-flex justify-content-center'
        }`}>
        {providerDetails ? (
          <div className="pt-4">
            <div
              className="banner"
              style={{
                backgroundImage: `url(${providerDetails.banner_image ?? banner})`,
              }}></div>
            <div className="row mt-4">
              <div className="border-bottom border-gray-hr-light py-4 row gap-3">
                {/* logo */}
                <div
                  style={{
                    backgroundImage: `url(${providerDetails.logo_image ?? userImage})`,
                  }}
                  className="provider-logo col-12 col-md-1 ">
                </div>
                <div className="col-xl-11 col-lg-8 col-12 row">
                  {/* first row */}
                    <div className="col-12 col-lg-6 col-xl-4">
                      <div className="text-dark text-primary fsize-16 mb-2">{shared.lists.name}</div>
                      <p className="m-0 text-gray">
                      {providerDetails.name_en || providerDetails.name_ar
                        ? lang === 'en'
                          ? providerDetails.name_en
                          : providerDetails.name_ar
                        : '-'}
                      </p>                    
                    </div>
                    <div className="col-12 col-lg-6 col-xl-4 mt-4 mt-lg-0">
                      <div className="text-dark text-primary fsize-16 mb-2">{shared.lists.email}</div>
                      <div className="text-gray  fsize-16">{handleEmailChecker()}</div>
                    </div>
                    <div className="col-12 col-lg-6 col-xl-4 mt-xl-0 mt-4">
                      <div className="text-dark text-primary fsize-16 mb-2">{serviceProviders.list.category}</div>
                      <div className="flex-column text-gray  fsize-16 d-flex justify-content-start">
                        <p className={`text-gray  fsize-16`}>
                          {providerDetails.category
                            ? lang === 'en'
                              ? renderTextEllipsis(providerDetails.category.name_en)
                              : renderTextEllipsis(providerDetails.category.name_ar)
                            : serviceProviderCategories.viewCategory.noCategory}
                        </p>
                      </div>
                    </div>
                  {/* second row */}
                    <div className="col-12 col-lg-6 col-xl-4 mt-4 mt-xl-0">
                      <div className="text-dark text-primary fsize-16 mb-2">{serviceProviders.viewServiceProvider.joiningDate}</div>
                      <div className="text-gray  fsize-16">{providerDetails.joining_date ? providerDetails.joining_date : '-'}</div>
                    </div>
                    <div className="col-12 col-lg-6 col-xl-4 mt-4 mt-xl-0">
                      <div className="text-dark text-primary fsize-16 mb-2">{serviceProviders.viewServiceProvider.contract}</div>
                      <div className="text-gray  fsize-16">
                        {providerDetails.contract 
                          ? <a 
                              className='text-decoration-none text-secondary'
                              href={providerDetails.contract} 
                              target="_blank" 
                              rel="noopener noreferrer"
                            >
                            {renderTextEllipsis(providerDetails.contract?.split('/').slice(-1)[0].split('_').pop())}
                        </a> 
                      : '-'
                        }</div>
                    </div>
                </div>
              </div>
            </div>

            <div className='row mt-4'>
              <div className="col-12 col-lg-6 col-xl-4">
                <div className="text-dark text-primary fsize-16 mb-2">
                  {serviceProviders.viewServiceProvider.verificationDocument}
                  <Tooltip
                      title={serviceProviders.viewServiceProvider.verificationDocumentTooltip}
                    >
                      <ErrorOutlineOutlinedIcon color="secondary" className="mx-1"/>
                  </Tooltip>
                </div>
                <div className="text-secondary fsize-16">
                  {providerDetails.commercial_registration_file_url 
                    ? <a 
                        className='text-decoration-none text-secondary'
                        href={providerDetails.commercial_registration_file_url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        >
                          {renderTextEllipsis(providerDetails.commercial_registration_file_url?.split('/').slice(-1)[0].split('_').pop())}
                      </a> 
                    : '-'
                  }</div>
              </div>
              <div className="col-12 col-lg-6 col-xl-4 mt-4 mt-lg-0">
                <div className="text-dark text-primary fsize-16 mb-2">{serviceProviders.viewServiceProvider.documentNumber}</div>
                <div className="text-gray  fsize-16">
                  {providerDetails.commercial_registration_number 
                  ? providerDetails.commercial_registration_number 
                  : '-'}</div>
              </div>
              <div className="col-12 col-lg-6 col-xl-4 mt-4 mt-xl-0">
                <div className="text-dark text-primary fsize-16 mb-2">{serviceProviders.viewServiceProvider.documentExpiry}</div>
                <div className="text-gray  fsize-16">
                  {providerDetails.commercial_registration_expiry_date 
                  ? providerDetails.commercial_registration_expiry_date 
                  : '-'}</div>
              </div>
              <div className="col-12 col-lg-6 col-xl-4 mt-4">
                <div className="text-dark text-primary fsize-16 mb-2">{serviceProviders.viewServiceProvider.iban}</div>
                <div className="text-gray  fsize-16">{providerDetails.iban ? providerDetails.iban : '-'}</div>
              </div>
              <div className="col-12 col-lg-6 col-xl-4 mt-4">
                <div className="text-dark text-primary fsize-16 mb-2">{serviceProviders.viewServiceProvider.comissionValue}</div>
                <div className="text-gray  fsize-16">
                  {providerDetails.commission_type === mimarCommissionList.fixed_fees
                   ? providerDetails.commission_fixed_fees  + " " + serviceProviders.viewServiceProvider.SR + " - " + serviceProviders.viewServiceProvider.billedMonthly
                   : providerDetails.mimars_commission + " %" + " - " + serviceProviders.viewServiceProvider.perTransaction
                  }
                </div>
              </div>
            </div>

            {/* branches */}
            <div className="row mt-4 pb-5">
              <div className="col-12 mt-4">
                <div className="d-flex justify-content-between gap-3 flex-wrap">
                  <div>
                    <div className="text-dark text-primary fsize-16 mb-2">{serviceProviders.list.branches}</div>
                    <div className="flex-column text-gray  fsize-16 d-flex justify-content-start">
                      {providerDetails.branches?.length > 0 ? (
                        providerDetails.branches.map((branch) => (
                          <p
                            key={branch.id}
                            className="mb-1 text-gray  fsize-18 pointer"
                            onClick={() => {
                              viewBranchDetails(branch);
                            }}>
                            {lang === 'en' ? renderTextEllipsis(branch.name_en) : renderTextEllipsis(branch.name_ar)}
                          </p>
                        ))
                      ) : (
                        <p className="m-0 text-secondary fsize-18">{serviceProviders.viewServiceProvider.noBranches}</p>
                      )}
                    </div>
                  </div>
                  {isSuperAdmin() &&
                    providerDetails?.category !== null &&
                    providerDetails.status !== providerStatusList.blocked && (
                      <Button
                        label={
                          <>
                            <Add />
                            <span className="mx-2">{serviceProviders.list.addBranch}</span> 
                          </>
                        }
                        className={`fsize-14 text-white p-3 height-fit-content ${lang === 'en' ? 'me-3' : 'ms-3'}`}
                        onClick={() => {
                          openAddBranchFlow();
                        }}
                      />
                    )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <EmptyState
            subTitle={shared.noDataToShow}
            ButtonLabel={shared.back}
            handleBtnAction={() => {
              history.push(ROUTE_PATHS.serviceProviders);
            }}
          />
        )}
      </div>
      <Modal
        open={openDeleteConfirm}
        handleClose={() => setOpenDeleteConfirm(false)}
        title={serviceProviders.deleteServiceProvider.title}
        contentClass="mb-5 pb-2 text-primary"
        content={<span>{serviceProviders.deleteServiceProvider.deleteConfirmationMsg}</span>}
        confirmBtnTxt={shared.delete}
        isContentText={false}
        maxWidth="xs"
        cancelBtnTxt={shared.cancel}
        handleConfirm={handleDeleteServiceProvider}
        handleCancel={() => setOpenDeleteConfirm(false)}
        modalClass="delete-provider-modal"
        actionsClass="container px-4"
        confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
        cancelBtnClass="fsize-14 py-2"
      />
      <Modal
        open={openShowPaswword && generatePassword}
        handleClose={() => setOpenShowPaswword(false)}
        title={serviceProviders.viewServiceProvider.showPasswordTitle}
        contentClass="mb-5 pb-2 text-primary"
        content={renderShowPassowrdContent()}
        isContentText={false}
        maxWidth="sm"
        cancelBtnTxt={shared.cancel}
        handleCancel={() => setOpenShowPaswword(false)}
        modalClass="generate-password-modal"
        actionsClass="container px-4"
        confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
        cancelBtnClass="fsize-14 py-2"
        disableActionBtn={generatePassword}
        disableBackdropClick={true}
      />
    </>
  );
};

export default ViewServiceProviders;
